'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GlobalEventsConnector = exports.Events = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _entries = require('babel-runtime/core-js/object/entries');

var _entries2 = _interopRequireDefault(_entries);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _bdcoreNamedRoutes = require('@bd/bdcore-named-routes');

var _bdcoreNamedRoutes2 = _interopRequireDefault(_bdcoreNamedRoutes);

var _ConfigStore = require('./ConfigStore');

var _ConfigStore2 = _interopRequireDefault(_ConfigStore);

var _selectors = require('@bd/bdcore-data/build/Homes/selectors');

var _selectors2 = require('@bd/bdcore-data/build/Plans/selectors');

var _selectors3 = require('@bd/bdcore-data/build/Lots/selectors');

var _selectors4 = require('@bd/bdcore-data/build/Communities/selectors');

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Events = exports.Events = function () {
  function Events() {
    (0, _classCallCheck3.default)(this, Events);

    this.eventListeners = {};
  }

  (0, _createClass3.default)(Events, [{
    key: 'setCurrent',
    value: function setCurrent(current) {
      if (current && current.name && (!this.current || this.current.url !== current.url)) {
        this.emit('Event::routeChange', { previous: this.current, current: current });
        this.current = current;
      }
    }
  }, {
    key: 'on',
    value: function on(name, cb, once) {
      if (!this.eventListeners[name]) {
        this.eventListeners[name] = [];
      }

      this.eventListeners[name].push({ cb: cb, once: once });
    }
  }, {
    key: 'once',
    value: function once(name, cb) {
      this.on(name, cb, true);
    }
  }, {
    key: 'off',
    value: function off(name, offCb) {
      if (this.eventListeners[name]) {
        this.eventListeners[name] = this.eventListeners[name].filter(function (_ref) {
          var cb = _ref.cb;
          return cb !== offCb;
        });
      }
    }
  }, {
    key: 'emit',
    value: function emit(name, data) {
      var current = this.current;
      // console.log(`Event::emit (${name})`, { current, ...data });
      if (this.eventListeners[name]) {
        this.eventListeners[name].forEach(function (_ref2) {
          var cb = _ref2.cb;

          try {
            cb((0, _extends3.default)({ current: current }, data));
          } catch (e) {
            console.error('Event::emit (' + name + ')', (0, _extends3.default)({ current: current }, data), e);
          }
        });
        this.eventListeners[name] = this.eventListeners[name].filter(function (_ref3) {
          var once = _ref3.once;
          return !once;
        });
      }
    }
  }]);
  return Events;
}();

var globalEvents = new Events();

globalEvents.once('ConfigStore::setConfig', function () {
  try {
    (0, _entries2.default)(_ConfigStore2.default.getConfig('global_events', {})).forEach(function (_ref4) {
      var _ref5 = (0, _slicedToArray3.default)(_ref4, 2),
          key = _ref5[0],
          value = _ref5[1];

      if (Array.isArray(value)) {
        value.forEach(function (cb) {
          return globalEvents.on(key, cb);
        });
      }
    });
  } catch (e) {
    console.error('global_events Config is invalid, must be an object');
  }
});

function Connector(_ref6) {
  var current = _ref6.current;

  globalEvents.setCurrent(current);
  return null;
}

var lastCurrent = void 0;

function forceRender(WrappedComponent) {
  var ForceRender = function (_React$Component) {
    (0, _inherits3.default)(ForceRender, _React$Component);

    function ForceRender(props) {
      (0, _classCallCheck3.default)(this, ForceRender);

      var _this = (0, _possibleConstructorReturn3.default)(this, (ForceRender.__proto__ || (0, _getPrototypeOf2.default)(ForceRender)).call(this, props));

      _this.onRoutesLoaded = function () {
        setTimeout(function () {
          _this.setState({ loaded: true });
        }, 0);
      };

      _this.state = {};
      globalEvents.once('Event::routesLoaded', _this.onRoutesLoaded);
      return _this;
    }

    (0, _createClass3.default)(ForceRender, [{
      key: 'render',
      value: function render() {
        if (this.state.loaded) {
          return _react2.default.createElement(WrappedComponent, this.props);
        }

        return null;
      }
    }]);
    return ForceRender;
  }(_react2.default.Component);

  return ForceRender;
}

var GlobalEventsConnector = exports.GlobalEventsConnector = forceRender((0, _reactRedux.connect)(function (state) {
  var builderId = _ConfigStore2.default.getConfig('builder_id');

  var match = _bdcoreNamedRoutes2.default.getRouteByPath(window.location.pathname);
  var current = lastCurrent;

  var dataFetchChecks = [_lodash2.default.get(state, 'cloudData.homes.' + builderId + '.isFetching'), _lodash2.default.get(state, 'cloudData.plans.' + builderId + '.isFetching'), _lodash2.default.get(state, 'cloudData.lots.' + builderId + '.isFetching'), _lodash2.default.get(state, 'cloudData.communities.' + builderId + '.isFetching')];

  if (_lodash2.default.get(lastCurrent, 'url') !== match.url && _lodash2.default.get(lastCurrent, 'name') !== match.name && _lodash2.default.some(dataFetchChecks, function (result) {
    return result === false;
  }) && _lodash2.default.every(dataFetchChecks, function (result) {
    return result !== true;
  })) {
    var home = (0, _selectors.getHome)(state, { match: match, builderId: builderId });
    var lot = (0, _selectors3.getLot)(state, { match: match, builderId: builderId });
    var community = (0, _selectors4.getCommunity)(state, { match: match, builderId: builderId, _id: _lodash2.default.get(home, 'containedIn', _lodash2.default.get(lot, 'containedIn')) });
    var plan = (0, _selectors2.getPlan)(state, { match: match, builderId: builderId, _id: _lodash2.default.get(home, 'plan') });

    current = {
      name: match ? match.name : undefined,
      match: match,
      home: home,
      lot: lot,
      community: community,
      plan: plan,
      url: match.url
    };

    lastCurrent = current;
  }

  return {
    current: current
  };
})(Connector));

exports.default = globalEvents;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-utilities/build/Events.js
// module id = 258
// module chunks = 0